import React from 'react'
import { Input, FieldWrapper, Modal } from '../../../shared/ui'
import { DefaultDurations } from '../model/types'

interface Props {
  show: boolean
  setShow: (show: boolean) => void
  taskTitle: string
  technicianName: string | null
  workDateTime: { date: string; time: string } | null
  durations: DefaultDurations
  onDurationsChange: (durations: DefaultDurations) => void
  collisionWarning?: boolean
  onSave: () => void
  canSave: boolean
  isPending: boolean
}

export const DraftTaskForm: React.FC<Props> = ({
  show,
  setShow,
  taskTitle,
  technicianName,
  workDateTime,
  durations,
  onDurationsChange,
  collisionWarning = false,
  onSave,
  canSave,
  isPending,
}) => {
  return (
    <Modal
      show={show}
      setShow={setShow}
      title="Aufgabe planen"
      submitButton={{ onSubmit: onSave, title: 'Speichern', isPending, disabled: !canSave }}
    >
      <div className="grid grid-cols-2 gap-x-8 gap-y-4 min-w-[480px] py-2">
        {/* Left column — Info */}
        <div className="flex flex-col gap-4">
          <FieldWrapper label="Aufgabe">
            <Input value={taskTitle} disabled />
          </FieldWrapper>

          <FieldWrapper label="Techniker">
            <Input value={technicianName ?? '—'} disabled />
          </FieldWrapper>

          {workDateTime && (
            <>
              <FieldWrapper label="Datum">
                <Input value={workDateTime.date} disabled />
              </FieldWrapper>
              <FieldWrapper label="Arbeitsbeginn">
                <Input value={workDateTime.time} disabled />
              </FieldWrapper>
            </>
          )}
        </div>

        {/* Right column — Durations */}
        <div className="flex flex-col gap-4">
          <FieldWrapper label="Anfahrt (min)">
            <Input
              type="number"
              value={String(durations.plannedTravelDuration)}
              step={15}
              onChange={(v) => {
                const n = parseInt(v, 10)
                if (!isNaN(n) && n >= 0)
                  onDurationsChange({ ...durations, plannedTravelDuration: n })
              }}
            />
          </FieldWrapper>

          <FieldWrapper label="Arbeit (min)">
            <Input
              type="number"
              value={String(durations.plannedWorkDuration)}
              step={15}
              onChange={(v) => {
                const n = parseInt(v, 10)
                if (!isNaN(n) && n >= 15)
                  onDurationsChange({ ...durations, plannedWorkDuration: n })
              }}
            />
          </FieldWrapper>

          <FieldWrapper label="Abfahrt (min)">
            <Input
              type="number"
              step={15}
              value={String(durations.plannedDepartureDuration)}
              onChange={(v) => {
                const n = parseInt(v, 10)
                if (!isNaN(n) && n >= 0)
                  onDurationsChange({ ...durations, plannedDepartureDuration: n })
              }}
            />
          </FieldWrapper>
        </div>

        {collisionWarning && (
          <p className="col-span-2 text-sm text-red-500 font-medium">
            Zeitüberschneidung mit einem bestehenden Termin.
          </p>
        )}
      </div>
    </Modal>
  )
}
